import React, { Component } from "react";
import { Row, Col, Divider, Input, Button } from "antd";
import { Link } from "react-router-dom";

class LegalNotice extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="wrap-body-inner">
        <div>
          <div className="row">
            <div>
              <div
                id="home"
                className="home-div"
                style={{
                  //maxHeight: "100em",
                  marginTop: "12em",
                  //width: "100vw",
                }}
              >
                {" "}
                <Row
                  className="home-row"
                  style={{
                    maxWidth: "90em",
                    margin: "auto",
                  }}
                >
                  <Col
                    sm={24}
                    md={24}
                    style={{
                      margin: "auto",
                      textAlign: "left",
                      marginTop: "3em",
                      marginBottom: "3em",
                    }}
                  >
                    <h2
                      style={{
                        marginTop: "0em",
                        color: "white",
                        fontWeight: 700,
                        fontSize: 30,
                        padding: "30px",
                        paddingTop: 0,
                        lineHeight: "1em",
                      }}
                    >
                      PRIVACY
                    </h2>

                    <div
                      style={{
                        margin: "auto",
                        fontWeight: 100,
                        color: "white",
                        fontWeight: 400,
                        fontSize: 17,
                        maxWidth: "90em",
                        padding: "30px",
                        paddingTop: 0,
                        textAlign: "left",
                      }}
                    >
                      We do not disclose any personal information to any third
                      parties unless we have the data subjects' permission
                      and/or consent.
                      <br />
                      <br />
                      We utilize the data we receive and collect to provide you
                      with relevant information, products, and services, to
                      refer you to appropriate third-party service providers, to
                      communicate with you, and to offer effective services.
                      <br />
                      <br />
                      Valor Motor Group (Pty) Ltd collects personal information
                      directly or indirectly from data subjects. We process this
                      information solely for the purposes for which it was
                      collected and for which consent was provided. Additional
                      personal information may be collected through email
                      correspondence, personal meetings, and telephone
                      interactions with the data subjects. Furthermore, Valor
                      Motor Group (Pty) Ltd may gather personal information
                      about the data subjects from third parties if necessary to
                      perform a requested service. By requesting services from
                      Valor Motor Group (Pty) Ltd or engaging with us, the data
                      subject consents to the collection, processing, and any
                      further necessary collection of personal information to
                      fulfil the business purpose.
                      <br />
                      <br />
                      Our website or social media platforms may contain links to
                      third-party websites, mobile applications, or services.
                      Please be aware that we are not responsible for the
                      privacy practices of these third parties and recommend
                      reading the privacy statements of each website you visit
                      that collects personal information.
                    </div>
                    <div
                      style={{
                        margin: "auto",
                        fontWeight: 100,
                        color: "white",
                        fontWeight: 400,
                        fontSize: 17,
                        maxWidth: "90em",
                        padding: "30px",
                        paddingTop: "0em",
                        textAlign: "left",
                      }}
                    >
                      <span
                        style={{
                          fontWeight: 600,
                        }}
                      >
                        Contact Information:{" "}
                      </span>
                      For any inquiries regarding the Company's Privacy Policy
                      or the handling of personal information, please contact
                      our Information Officer:
                      <br />
                      <br />
                      <ul
                        style={{
                          fontWeight: 400,
                          lineHeight: "2em",
                          marginTop: "0em",
                        }}
                      >
                        <li>
                          Information Officer:{" "}
                          <span
                            style={{
                              fontWeight: 600,
                              lineHeight: "2em",
                            }}
                          >
                            Marcelle van der Mescht
                          </span>{" "}
                        </li>
                        <li>
                          Telephone number:{" "}
                          <span
                            style={{
                              fontWeight: 600,
                              lineHeight: "2em",
                            }}
                          >
                            018 518 0111
                          </span>{" "}
                        </li>
                        <li>
                          Email:{" "}
                          <span
                            style={{
                              fontWeight: 600,
                              lineHeight: "2em",
                            }}
                          >
                            marcelle@vmg.co.za
                          </span>{" "}
                        </li>
                      </ul>
                    </div>
                    <Divider
                      orientation="right"
                      style={{ borderTopColor: "rgba(0, 0, 0, 0.25)" }}
                    >
                      <Link to="/home">
                        <Button
                          style={{
                            float: "right",
                            height: "2.7em",
                            width: "10em",
                            fontSize: "17px",
                            fontWeight: 500,
                            borderRadius: "3em",
                            color: "white",
                            border: "none",
                            marginTop: "1em",
                            marginBottom: "1em",
                            backgroundColor: "#cd2934",
                            textShadow: "none",
                            boxShadow: "none",
                          }}
                        >
                          Back to Home
                        </Button>
                      </Link>
                    </Divider>
                  </Col>
                </Row>{" "}
              </div>{" "}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default LegalNotice;
